const GiftMessage = (props) => {
  const { reservation } = props;
  if (!reservation.notes || reservation.notes === '') {
    return null;
  }
  return (
    <div className="c7-order__customer-detail">
      <h4>Notes or dietary restrictions</h4>
      <p>{reservation.notes}</p>
    </div>
  );
};

export default GiftMessage;
